<template>
    <div>
        <div class="content w1200">
            <div class="left">
                <kaijiang></kaijiang>
                <div>
                    <div class="svc-card" @click="openInNewTab('/dataupdate', 7)">
                        <div class="svc-card__head">
                            <span class="svc-card__name">任意软件开奖数据更新</span>
                            <span class="svc-card__badge">推荐</span>
                        </div>
                        <div class="svc-card__desc">上传旧数据 · 一键转标准格式</div>
                        <div class="svc-card__btn">立即使用 →</div>
                    </div>
                </div>
            </div>
            <div class="cont">
                <el-carousel height="475px">
                    <el-carousel-item v-for="(item, index) in banner" :key="index">
                        <el-image style="width: 100%; height: 100%;" :src="item.img" fit="fit"
                            @click="gotoPage(item)"></el-image>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="right">
                <div class="rg_one">
                    <div class="user" @click="$router.push('/personalCenter/userinfo/yhzx')"><b>{{
                        vuex_userInfo.nickName
                        || '' }}</b> 欢迎您</div>
                    <div class="shrinkRecharge" @click="$router.push('/personalCenter/chongzhihetixian/suobichongzhi')">
                        <span>缩币充值</span>
                    </div>
                </div>
                <div class="cont">
                    <div class="nav">
                        <span v-for="(item, index) in notice_help.nav.arr" :key="index"
                            :class="{ active: notice_help.nav.active == index }"
                            @click="notice_help.nav.active = index; getHelp_notice(index)">{{ item }}</span>
                    </div>
                    <div class="list">
                        <template v-if="notice_help.nav.active == 0">
                            <div v-for="(item, index) in notice_help.noticeList" :key="index"
                                @click="gotoArticle_details(item, 'notice')">
                                <div>{{ item.noticeTitle }}</div>
                                <span style="width: 100px; text-align: right;">{{ item.createTime.substring(2, 10)
                                }}</span>
                            </div>
                        </template>
                        <template v-if="notice_help.nav.active == 1">
                            <div v-for="(item, index) in notice_help.helpList" :key="index"
                                @click="gotoArticle_details(item, 'help')">
                                <div>{{ item.title }}</div>
                                <span>{{ item.createTime.substring(2, 10) }}</span>
                            </div>
                        </template>
                    </div>
                </div>
                <!-- <div class="btn" v-if="!vuex_userInfo.nickName">
                    <div @click="$router.push('/login')">登录</div>
                    <div @click="$router.push('/login/register')">注册</div>
                    <div @click="$router.push('/login/forgetPassword')">
                        忘记密码
                    </div>
                </div> -->
            </div>
        </div>

        <ssq></ssq>
        <!-- 大乐透/福彩3D/排列三 三个频道：滚动到可视区才挂载并请求，降低首屏并发 -->
        <div class="lazy-wrap" data-channel="dlt" ref="lazydlt">
            <dlt v-if="lazyLoaded.dlt"></dlt>
        </div>
        <div class="lazy-wrap" data-channel="fcsd" ref="lazyfcsd">
            <fcsd v-if="lazyLoaded.fcsd"></fcsd>
        </div>
        <div class="lazy-wrap" data-channel="pls" ref="lazypls">
            <pls v-if="lazyLoaded.pls"></pls>
        </div>

        <img src="@/assets/indexBottom.png" alt="" class="w1200" style="margin: 20px auto; display: block" />

        <div class="dibudaxiang">
            <span @click="openInNewTab('/ssddt', 1)">缩水单大厅</span>
            <span @click="openInNewTab('/excel', 4)">EXCEL转场</span>
            <span @click="openInNewTab('/suoshuiruanjian', 5)">缩水软件特区</span>
            <span @click="openInNewTab('/sttzzbfzx', 6)">投注站帮扶中心</span>
        </div>

    </div>
</template>

<script>
import ssq from "./template/ssq.vue";
import dlt from "./template/dlt.vue";
import fcsd from "./template/fcsd.vue";
import pls from "./template/pls.vue";
import kaijiang from "./template/kaijiang.vue";

import { bannerApi, help, notice, queryPreRankingList } from '@/api/home/index'

export default {
    components: { ssq, dlt, fcsd, pls, kaijiang, },
    data() {
        return {
            banner: [],
            notice_help: {
                nav: {
                    active: 0,
                    arr: ["网站公告", "帮助中心"],
                },
                noticeList: [],
                helpList: [],
            },
            // 大乐透/福彩3D/排列三 三频道滚动到可视区才挂载，从而降低首屏并发请求数
            lazyLoaded: { dlt: false, fcsd: false, pls: false },
        };
    },
    mounted() {
        this.getBanner()
        this.getHelp_notice()
        this.initLazyChannels()
        // 首屏空闲时静默预热其余三频道(dlt/fcsd/pls)的后台冷查询：利用 requestIdleCallback（不支持则降级 setTimeout），
        // 提前把这三频道的 ranking/forecast 默认请求发出去跑完，结果写入前端缓存；用户滚动到对应频道、懒加载组件挂载时
        // 同参命中缓存秒回，避免滚动时撞上首次冷查询（会卡）。预取与组件同参，接口内飞行中去重合并为一次请求。
        const idle = window.requestIdleCallback || (cb => setTimeout(cb, 800))
        idle(() => this.prefetchChannels())
    },
    beforeDestroy() {
        if (this._lazyObserver) {
            this._lazyObserver.disconnect()
        }
    },
    methods: {
        // 大乐透/福彩3D/排列三 三频道：进入视口(提前200px)才挂载，未挂载时其内部子组件的请求不会发出
        initLazyChannels() {
            if (typeof IntersectionObserver === 'undefined') {
                // 不支持则直接全量渲染，保证功能可用
                this.lazyLoaded = { dlt: true, fcsd: true, pls: true }
                return
            }
            const io = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        const ch = entry.target.getAttribute('data-channel')
                        if (ch && !this.lazyLoaded[ch]) {
                            this.lazyLoaded[ch] = true
                            io.unobserve(entry.target)
                        }
                    }
                })
            }, { rootMargin: '200px 0px' })
            this._lazyObserver = io
            this.$nextTick(() => {
                ;['dlt', 'fcsd', 'pls'].forEach(ch => {
                    const el = this.$refs['lazy' + ch]
                    if (el) io.observe(el)
                })
            })
        },
        // 接口文档：preIndexType 有值 = 指标考核导航的排名；不填 = 指标学霸最新预测。
        // 故这里 preIndexType 只给 ranking 用（取各频道首项），forecast 不传。
        defaultPreIndexType(lotteryType) {
            return ['2', '3'].includes(String(lotteryType)) ? 5 : 7
        },
        // 首屏空闲静默预取 dlt(1)/fcsd(2)/pls(3) 三频道的 ranking + forecast 请求：
        // 触发后台冷查询并写入前端缓存；懒加载组件挂载时同参命中缓存秒回，不再请求后台。
        // 注意：ranking(带 preIndexType) 与 forecast(不带 preIndexType) 参数不同，是两个不同的后台查询，
        // 接口内去重不会合并，故每频道各发 1 个，共 6 个，按频道错峰 200ms。
        prefetchChannels() {
            // 必须用字符串，与子组件的 lotteryType（模板里 lotteryType="2" 是字符串）保持一致，
            // 否则缓存 key 对不上（JSON.stringify({preType:2}) !== JSON.stringify({preType:"2"})），预取等于白做。
            const channels = ['1', '2', '3']
            channels.forEach((preType, i) => {
                setTimeout(() => {
                    // 指标排名：带 preIndexType（各频道首个 tab）
                    queryPreRankingList({
                        preType,
                        preIndexType: this.defaultPreIndexType(preType),
                        risingNo: 10,
                    })
                    // 指标学霸最新预测：不传 preIndexType
                    queryPreRankingList({ preType, risingNo: 10 })
                }, i * 200) // 错峰 200ms，避免瞬间接连并发
            })
        },
        openInNewTab(path, menuActiveIndex = null) {

            if (menuActiveIndex === '') { return }

            this.$vuex('vuex_menuActiveIndex', menuActiveIndex)

            const env = process.env.NODE_ENV;
            let obj = {
                development: window.location.origin, // 本地开发：跟随 dev server 实际地址（如 http://localhost:8085）
                production: process.env.VUE_APP_BASE_API, // 线上地址
            }

            const fullUrl = `${obj[env]}#${path}`;
            window.open(fullUrl, '_blank');
        },
        getBanner() {
            bannerApi().then(res => {
                // 兼容多种返回结构：res.data 可能是数组，也可能 res 本身就是 {rows:[...]} 或裸数组
                const payload = res && res.data !== undefined ? res.data : res;
                    const rows = Array.isArray(payload) ? payload : (payload && payload.rows) || [];
                    // 图片地址统一走 $img（自动补前缀、去多余斜杠），避免手写拼接出现 //stage-api 双斜杠
                    this.banner = rows
                        .filter(item => item.status == 0)
                        .map(item => ({ ...item, img: this.$img(item.img) }));
            }).catch(err => {
                console.error('banner 加载失败', err);
                this.banner = []
            })
        },
        gotoPage(item) {
            if (!item || !item.link) return
            window.open(item.link, '_blank')
        },

        getHelp_notice(index = 0) {
            const isNotice = index == 0;
            // 兼容多种返回结构：res.data 可能是数组，也可能 res 本身就是 {rows:[...]} 或裸数组
            const extract = (res) => {
                const payload = res && res.data !== undefined ? res.data : res;
                const rows = Array.isArray(payload) ? payload : (payload && payload.rows) || [];
                return rows.slice(0, 9)
            }

            const key = isNotice ? 'noticeList' : 'helpList';
            const req = isNotice ? notice(index) : help();
            req.then(res => {
                this.notice_help[key] = extract(res)
            }).catch(err => {
                console.error(isNotice ? '公告加载失败' : '帮助中心加载失败', err);
                this.notice_help[key] = []
            })
        },

        gotoArticle_details(item, type) {
            // console.log('ss',JSON.parse(JSON.stringify(item)));
            let id = type == 'notice' ? item.noticeId : item.id;
            // console.log('id',id);
            // this.$vuex('vuex_articleDetails', item)
            this.$router.push({
                name: 'article_details',
                query: { id, type }
            })
        }
    }
};
</script>

<style lang="scss" scoped>
.content {
    border: 1px solid rgba(0, 0, 0, 0.2);
    display: flex;

    >div {

        &.left,
        &.right {
            width: 300px;
            position: relative;

            .btn {
                display: flex;

                div {
                    width: 33%;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    text-align: center;
                    padding: 10px 0;
                    cursor: pointer;
                }
            }
        }

        &.cont {
            flex: 1;
            background: rgba(0, 0, 0, 0.2);
        }

        &.left {
            .title {
                padding: 20px;
                padding-bottom: 10px;
                font-size: 20px;
                border-bottom: 1px solid rgba(0, 0, 0, 0.2);
            }

            >div:nth-child(n + 2) {

                .tit {
                    font-size: 20px;
                    padding: 15px 0 5px;
                }

                .cont {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);

                    span {
                        padding: 2px 0;
                        font-size: 14px;
                        cursor: pointer;
                        width: max-content;

                        transform-origin: center;
                        transition: transform 0.5s;

                        position: relative;
                        color: #3072cd;

                        &:hover {
                            transform: scale(1.5);
                            font-weight: bold;

                            // text-decoration: underline;
                            &::after {
                                width: 100%;
                                left: 0%;
                            }
                        }

                        &:not(:hover) {
                            transform: scale(1);
                            font-weight: inherit;

                            &::after {
                                width: 0%;
                                left: 50%;
                            }
                        }

                        &::after {
                            content: '';
                            display: block;
                            border-bottom: 3px solid #3072cd;
                            width: 0%;
                            position: absolute;
                            left: 50%;
                            transition: width 0.5s linear, left 0.5s linear;
                        }
                    }
                }
            }

            // 数据服务入口：做成高亮卡片，避免被当作普通文字链接忽略
            .svc-card {
                margin: 10px;
                padding: 12px 14px;
                border-radius: 8px;
                background: linear-gradient(135deg, #3072cd 0%, #5b9bf5 100%);
                color: #fff;
                cursor: pointer;
                box-shadow: 0 4px 12px rgba(48, 114, 205, 0.35);
                transition: transform 0.25s, box-shadow 0.25s;

                &:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 8px 18px rgba(48, 114, 205, 0.5);
                }

                &__head {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                }

                &__name {
                    font-size: 15px;
                    font-weight: 700;
                    letter-spacing: 0.5px;
                }

                &__badge {
                    font-size: 11px;
                    line-height: 1;
                    padding: 3px 6px;
                    border-radius: 3px;
                    background: #ffd666;
                    color: #ad6800;
                    font-weight: 700;
                }

                &__desc {
                    font-size: 12px;
                    opacity: 0.9;
                    margin-top: 6px;
                }

                &__btn {
                    margin-top: 10px;
                    padding: 5px 0;
                    font-size: 12px;
                    text-align: center;
                    border-radius: 4px;
                    background: rgba(255, 255, 255, 0.22);
                    transition: background 0.25s;

                    &:hover {
                        background: rgba(255, 255, 255, 0.35);
                    }
                }
            }
        }

        &.right {
            padding: 10px;

            .rg_one {
                display: flex;

                >div {
                    cursor: pointer;
                    height: 50px;
                    line-height: 50px;
                    flex: 1;
                    text-align: center;
                    border: 1px solid rgba(0, 0, 0, 0.2);
                    position: relative;

                    &.user {
                        background-color: #f4ce98;
                        color: #bd392f;
                    }

                    &.shrinkRecharge {
                        // background-color: #347CAF;
                        background-color: red;
                        color: #fff;
                        flex: 0.4;
                        transition: padding 0.5s linear;

                        &:hover {
                            padding: 0 30px;

                            &::after {
                                width: 100%;
                                left: 0%;
                            }
                        }

                        &:not(:hover) {
                            padding: 0 0px;
                            font-weight: inherit;

                            &::after {
                                width: 0%;
                                left: 50%;
                            }
                        }

                        &::after {
                            content: '';
                            display: block;
                            border-bottom: 3px solid #3072cd;
                            width: 0%;
                            position: absolute;
                            left: 50%;
                            transition: width 0.5s linear, left 0.5s linear;
                        }
                    }
                }
            }

            .cont {
                margin: auto;
                // border: 1px solid red;
                display: flex;
                flex-direction: column;
                align-items: center;

                .nav {
                    width: 65%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    margin: 0px 0 5px;
                    color: #347caf;
                    font-weight: bold;

                    span {
                        cursor: pointer;
                        font-size: 20px;
                        border-bottom: 3px solid rgba(0, 0, 0, 0.1);
                        padding: 10px 0;
                        text-align: center;

                        &.active {
                            border-bottom: 3px solid #347caf;
                        }
                    }
                }

                .list {
                    width: 95%;

                    div {
                        display: flex;
                        justify-content: space-between;
                        // padding: 10px;
                        line-height: 30px;
                        cursor: pointer;

                        div {
                            text-overflow: ellipsis;
                            white-space: nowrap;
                            overflow: hidden;
                            display: block;

                            &:hover {
                                transition: transform 0.5s;
                                transform: scale(1.1);
                                font-weight: bold;
                                transform-origin: left;
                            }

                            &:not(:hover) {
                                transition: transform 0.5s;
                                transform: scale(1);
                                font-weight: inherit;
                                transform-origin: left;
                            }
                        }

                        span {
                            white-space: nowrap;
                        }
                    }
                }
            }
        }
    }
}

.dibudaxiang {
    width: 930px;
    margin: 50px auto 80px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;

    span {
        white-space: nowrap;
        padding: 15px 50px;
        border: 2px solid #3d82b2;
        color: #3d82b2;
        font-weight: bold;
        border-radius: 10px;
    }
}

/* 懒加载频道占位：给占位容器一定高度，避免布局跳动，同时让 IntersectionObserver 有可观察的体积 */
.lazy-wrap {
    min-height: 400px;
}

/* ===== 移动端适配（屏幕小于 1200px 即生效，与 .w1200 容器自适应保持一致） ===== */
@media (max-width: 1200px) {
    .lazy-wrap {
        min-height: 200px;
    }
    /* 主三栏改纵向堆叠 */
    .content {
        flex-direction: column;

        > div {
            &.left,
            &.right {
                width: 100%;
            }

            &.right {
                padding: 10px 0;
            }

            &.cont {
                // 轮播高度在移动端降低，由下方 ::v-deep 统一覆盖
            }
        }
    }

    /* 轮播容器在移动端降低高度 */
    ::v-deep .el-carousel,
    ::v-deep .el-carousel__container {
        height: 200px !important;
    }

    /* 底部大项导航：换行居中 */
    .dibudaxiang {
        width: 100%;
        flex-wrap: wrap;
        justify-content: center;
        gap: 12px;
        margin: 30px auto 50px;

        span {
            padding: 12px 18px;
            font-size: 14px;
            white-space: nowrap;
        }
    }

    /* 底部配图全宽 */
    img.w1200 {
        width: 100% !important;
        margin: 15px auto !important;
    }

    /* 子彩票模块：双栏转纵向 */
    ::v-deep {
        .one,
        .two {
            flex-direction: column;
        }

        .one > div.right,
        .two > div.right {
            margin-left: 0;
            margin-top: 20px;
        }

        .one > div.right > div {
            &.left {
                border-right: none;
            }

            &.right {
                margin-left: 0;
                margin-top: 20px;
            }
        }
    }
}
</style>